<template>
  <button
    v-bind="$attrs"
    class="btn btn-rounded shadow-none"
    :class="[itemClass, disabledButtonClass, onlyIconButtonPadding ? 'btn-size-padding' : '']"
    :disabled="disabled"
    @click="onClick"
  >
    <span
      v-if="loading"
      class="spinner-border spinner-border-sm me-1"
      :class="loaderColor"
      role="status"
      aria-hidden="true"
    />
    <i :class="iconClass" v-if="iconClass" />
    <slot />
  </button>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  onlyIconButtonPadding: {
    type: Boolean,
    required: false,
    default: false
  },
  itemClass: {
    type: String,
    required: false,
    default: 'btn-primary'
  },
  disabledClass: {
    type: String,
    default: 'disable-button'
  },
  iconClass: {
    type: String,
    required: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  primaryDisabledClass: {
    type: Boolean,
    default: false
  },
  loaderColor: {
    type: String,
    default: 'text-white'
  }
})

const emit = defineEmits(['click'])

const disabledButtonClass = computed(() => {
  if (props.disabled) {
    return props.primaryDisabledClass ? 'primaryDisabledClass' : props.disabledClass
  }
  return null
})

const paddingAccordingSizeButton = computed(() => {
  if (props.itemClass.includes('btn-lg')) {
    return '14px'
  } else if (props.itemClass.includes('btn-sm')) {
    return '10px'
  } else if (props.itemClass.includes('btn-xs')) {
    return '8px'
  }
  return '12px'
})

const onClick = event => {
  emit('click', event)
}
</script>

<style lang="scss" scoped>
.btn-size-padding {
  padding: v-bind('paddingAccordingSizeButton') !important;
}
.btn-borderless-primary {
  text-decoration-line: underline;
  background: transparent;
  color: #32a84b;
  &:hover {
    color: #28863c;
  }
  &:disabled {
    cursor: not-allowed;
    color: #a6a9a8;
  }
}
.btn-borderless-secondary {
  text-decoration-line: underline;
  background: transparent;
  color: #373838;
  &:hover {
    color: #252626;
  }
  &:disabled {
    cursor: not-allowed;
    color: #a6a9a8;
  }
}
.btn.btn-light:disabled,
.btn.btn-primary:disabled,
.btn.btn-secondary:disabled {
  cursor: not-allowed;
  background: #eaebeb !important;
  border-color: #eaebeb !important;
  color: #a6a9a8 !important;
}

.btn-outline-primary:disabled,
.btn-outline-secondary:disabled {
  cursor: not-allowed;
}

.btn-outline-primary {
  border-width: 1.2px;
}
.btn-outline-danger {
  border-width: 1.2px;
}
.btn-outline-secondary {
  border-width: 1.2px;
}

.btn-outline-warning {
  border-width: 1.2px;
  background-color: #fff;
  &:hover {
    color: #fff;
  }
}

.spinner-grow {
  vertical-align: middle;
}
.font-28 {
  font-size: 28px;
}
.disable-button {
  box-shadow: none;
  color: #a6a9a8 !important;
  background-color: #eaebeb !important;
  border: 0px;
}
.primaryDisabledClass {
  box-shadow: none;
  color: $primary !important;
  background-color: $primary !important;
  border: 0px;
}
.btn:active,
.btn:focus,
.btn.active,
.btn:active:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.btn-primary:focus,
.btn-primary.focus {
  background: $primary;
  box-shadow: 0 0 0 2px rgba(193, 229, 201, 1);
}
.btn-secondary:focus,
.btn-secondary.focus {
  box-shadow: 0 0 0 2px rgba(92, 94, 93, 1);
  background: $secondary;
}
</style>
